import { create } from 'apisauce'

import store from '../store'
import { getAPIEndpoint } from '../utils/apiConstants'
import handleNetworkError from '../actions/network'

const baseURL = `${getAPIEndpoint()}/system`
const apiSystem = create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const checkForToken = () => `bearer ${store.getState().user && store.getState().user.access_token}`

apiSystem.axiosInstance.interceptors.request.use(
  (config) => {
    const newConfig = {
      ...config,
      headers: { ...config.headers, Authorization: checkForToken() },
    }
    return newConfig
  },
  (error) =>
    Promise.reject(error)
  ,
)

apiSystem.axiosInstance.interceptors.response.use(
  response => (
    response
  ), (error) => new Promise((resolve, reject) => {
    if (error.response.status === 401) {
      // callToLogin()
      return
    }
    if (error.response.status && error.response.data) {
      store.dispatch(handleNetworkError(error.response.status, error.response.data))
    }
    reject(error)
  }),
)

apiSystem.axiosInstance.interceptors.request.use(config =>
  (config)
  , (error) => {
  console.log(error)
  return Promise.reject(error)
})

export default apiSystem
